import gql from 'graphql-tag';

export default gql`
  mutation($input: ConfirmSSOLinkInput!) @api(name: "auth") {
    confirmSSOLink(input: $input) {
      data {
        user {
          id
          email
          username
          phone
          document
        }
        # customDomain
        customFields
      }
      organizationId
      token
    }
  }
`;

export type ConfirmSSOLinkVariables = {
  input: {
    userId: string;
    consultantId: string;
  };
};

export type ConfirmSSOLinkResponse = {
  confirmSSOLink: {
    data: {
      user: User;
      customFields: { key: string; value: string }[];
    };
    organizationId: string;
    token?: string;
  };
};
